import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import Topbar from '../components/Topbar'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const MainLayout: React.FC = () => {
  const location = useLocation()
  const { isAuthenticated } = useAuth0();
  const isQrCodeTemplate = location.pathname.includes('/qr-code-template')

  // Hide navbar for non-authenticated users on device detail pages
  const isDeviceDetailPage = /^\/devices\/[a-zA-Z0-9-]+$/.test(location.pathname)
  const hideNavbar = isQrCodeTemplate

  return (
    <div className="app-root">
      <Topbar />
      {!hideNavbar && <Navbar />}
      <div className={`app-shell${hideNavbar ? ' no-navbar' : ''}`}>
        <main className="app-main">
          <div className="main-content">
            <Outlet />
          </div>
        </main>
      </div>
      <Footer />
    </div>
  )
}

export default MainLayout
